import VueHotjar from 'vue-hotjar-next'
import { useConsentStore } from '@/stores/consent'

const HOTJAR_ID = import.meta.env.VITE_HOTJAR_ID
let initialized = false

function isEnabled() {
    if (!import.meta.env.PROD || !HOTJAR_ID) return false
    const host = window.location.host
    if (host.includes('localhost') || host.includes('uat.')) return false
    return true
}

function consentGranted() {
    try {
        return useConsentStore().analyticsGranted
    } catch {
        return false
    }
}

export function initHotjar(app) {
    if (!isEnabled() || initialized) return
    if (!consentGranted()) return
    initialized = true

    app.use(VueHotjar, {
        id: Number(HOTJAR_ID),
        isProduction: true,
    })
}

export function identifyHotjarUser(userData, userType) {
    if (!isEnabled() || typeof window.hj !== 'function') return
    if (!consentGranted()) return

    if (userType === 'internal') return

    const domain = userData.email?.split('@')[1] || ''

    window.hj('identify', userData.id, {
        user: `${domain}-user-${userData.id}` || '',
        is_owner: userData.id === userData.owned_by,
        owner_id: userData.owned_by,
        owner_domain: userData.owner_email?.split('@')[1] || '',
        user_type: userType || 'external',
        user_roles: userData.roles?.[0] || 'unknown',
        account_plan: userData.account_plan || 'unknown',
        onboarding_status: userData.onboarding_status || 'unknown',
        signup_date: userData.registered_at || '',
        locale: userData.preferred_locale || 'unknown',
    })
}

export function trackHotjarEvent(eventName) {
    if (!isEnabled() || typeof window.hj !== 'function') return
    if (!consentGranted()) return
    window.hj('event', eventName)
}

export function resetHotjarUser() {
    if (!isEnabled() || typeof window.hj !== 'function') return
    if (!consentGranted()) return
    window.hj('identify', null, {})
}
